import { useCallback, useEffect, useState } from 'react';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from '../utils/safeStorage';

export type ForgeTheme = 'dark' | 'light';

const STORAGE_KEY = 'forge-theme';

function readStoredTheme(): ForgeTheme {
  const stored = safeLocalStorageGetItem(STORAGE_KEY);
  // 'beige' was a retired third mode; readers on that choice land on light.
  if (stored === 'light' || stored === 'beige') return 'light';
  return 'dark';
}

export function useForgeTheme() {
  const [theme, setTheme] = useState<ForgeTheme>(readStoredTheme);

  useEffect(() => {
    safeLocalStorageSetItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme } as const;
}
